var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPartnership(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.464844 10.0508C0.464844 4.52793 4.942 0.0507812 10.4648 0.0507812H38.4648C43.9877 0.0507812 48.4648 4.52793 48.4648 10.0508V38.0508C48.4648 43.5736 43.9877 48.0508 38.4648 48.0508H10.4648C4.942 48.0508 0.464844 43.5736 0.464844 38.0508V10.0508Z",
    fill: "#155DFC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4648 29.0508L25.4648 31.0508C25.6618 31.2478 25.8957 31.404 26.153 31.5106C26.4104 31.6172 26.6863 31.6721 26.9648 31.6721C27.2434 31.6721 27.5193 31.6172 27.7766 31.5106C28.034 31.404 28.2679 31.2478 28.4648 31.0508C28.6618 30.8538 28.8181 30.6199 28.9247 30.3626C29.0313 30.1052 29.0862 29.8294 29.0862 29.5508C29.0862 29.2722 29.0313 28.9964 28.9247 28.739C28.8181 28.4816 28.6618 28.2478 28.4648 28.0508",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4651 26.0513L28.9651 28.5513C29.3629 28.9491 29.9025 29.1726 30.4651 29.1726C31.0277 29.1726 31.5672 28.9491 31.9651 28.5513C32.3629 28.1535 32.5864 27.6139 32.5864 27.0513C32.5864 26.4887 32.3629 25.9491 31.9651 25.5513L28.0851 21.6713C27.5226 21.1095 26.7601 20.7939 25.9651 20.7939C25.1701 20.7939 24.4076 21.1095 23.8451 21.6713L22.9651 22.5513C22.5672 22.9491 22.0277 23.1726 21.4651 23.1726C20.9025 23.1726 20.3629 22.9491 19.9651 22.5513C19.5672 22.1535 19.3438 21.6139 19.3438 21.0513C19.3438 20.4887 19.5672 19.9491 19.9651 19.5513L22.7751 16.7413C23.6873 15.8314 24.877 15.2518 26.1557 15.0943C27.4345 14.9367 28.7292 15.2101 29.8351 15.8713L30.3051 16.1513C30.7309 16.4083 31.2371 16.4974 31.7251 16.4013L33.4651 16.0513",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4648 15.0508L34.4648 26.0508H32.4648",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4648 15.0508L14.4648 26.0508L20.9648 32.5508C21.3627 32.9486 21.9022 33.1721 22.4648 33.1721C23.0275 33.1721 23.567 32.9486 23.9648 32.5508C24.3627 32.153 24.5862 31.6134 24.5862 31.0508C24.5862 30.4882 24.3627 29.9486 23.9648 29.5508",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4648 16.0508H23.4648",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartnership);
export default __webpack_public_path__ + "static/media/Partnership.655e25e6b4040b6de5f8a45dcdd4e46f.svg";
export { ForwardRef as ReactComponent };